import React, { useEffect, useState } from "react";
import { fetchCertificateDetails, fetchSettings } from "./fetchHandler";
import { useLocation, useParams } from "react-router-dom";
import { DOMAIN } from "../../global";
import QRCode from "react-qr-code";
import { getPermissions } from "../rbac/hasAccess";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import { DateisValid } from "../../utils/commonComponent/errorAlert";
import LoaderModal from "../../utils/loader.js/loader";
import { generateCertificatePDF } from "./printCertificate/printCertifcate";
import { Autocomplete, Box, Button, TextField, Toolbar } from "@mui/material";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import RejectModal from "./rejectModal";
import { auhtorityWiseApprove } from "./auhtorityWiseApprove";
import RenderStaticTables from "./renderTables";
import { parseDepth } from "../../utils/commonComponent/parse";
import { handleWithdrawApproval } from "./handleWithdrawApproval";
import { getCustomerDetails, summaryLable } from "./certConst";
  

const ViewCertificate = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [letterHead, setLetterHead] = useState(true);
  const [draft, setDraft] = React.useState(false);
  const [scanCopy, setScanCopy] = React.useState(false);
  const [electronicSign, setElectronicSign] = useState(true);
  const [certificateDetails, setCertificateDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [roles, setRoles] = useState([]);
  const [settings, setSettings] = useState({});
  const [allSettings, setAllSettings] = useState([]);
  const userType = localStorage.getItem("type");

  // qr code download pdf
  const location = useLocation();
  const isPrintRoute = location.pathname.startsWith("/certificate/print/");
  const [pdfTriggered, setPdfTriggered] = useState(false);

  const handleClose = () => setModalOpen(false);

  const handleReject = (reason) => {
    const cert = certificateDetails?.[0];
    if (!cert) return;
    const testedBy = [cert?.observationSheets?.[0]?.observationSheet_testedBy, "Tested By"];
    const authorizedBy = [cert?.certificate_authorizedBy, "Authorized By"];
    auhtorityWiseApprove("reject", [cert?.id], testedBy, reason, props.rolesInfo?.currentRole?.name, authorizedBy);
    setModalOpen(false);
  };

  // ── Common helper: get the final approval field based on active roles ──
  const getFinalApprovalValue = (cert) => {
    const isRoleActive = (keyName) =>
      allSettings.some((s) => s.keyName === keyName && Number(s.status) === 1 && s.value !== "false");

    if (isRoleActive("activeRole4")) return cert?.certificate_authorizedBy;
    if (isRoleActive("activeRole3")) return cert?.certificate_reviewedBy;
    if (isRoleActive("activeRole2")) return cert?.certificate_preparedBy;
    return cert?.certificate_authorizedBy; // fallback to old logic
  };

  useEffect(() => {
    const fetchData = async (params) => {
      setLoading(true);
      const data = await fetchCertificateDetails(params);
      setCertificateDetails(Array.isArray(data) ? data : [data]);
      setLoading(false);
    };
    fetchData(params);
  }, [params]);

  useEffect(() => {
    fetchSettings().then(({ roleSettings, settings, allSettings }) => {
      const mappedRoles = Object.entries(roleSettings)?.map(([key, item]) => ({
        name: item.name,
        id: key,
        label: item.name,
        key: key,
      }));
      setRoles(mappedRoles);
      setSettings(settings);  // Save settings as 
      setAllSettings(allSettings);
    });
  }, []);

  useEffect(() => {
    if (certificateDetails.length == 1 && !getFinalApprovalValue(certificateDetails[0])) {
      setDraft(true);
      setLetterHead(false);
      setScanCopy(false);
    }
  }, [certificateDetails]);

  useEffect(() => {
    if (isPrintRoute && !pdfTriggered && !loading && certificateDetails.length > 0) {
      setPdfTriggered(true);
      const isDraft = !getFinalApprovalValue(certificateDetails[0]);
      generateCertificatePDF({
        letterHead: isDraft ? false : true,
        draft: isDraft ? true : false,
        scanCopy: false,
        electronicSign: true,
        certificateDetails,
        setLoading,
      });
    }
  }, [isPrintRoute, loading, certificateDetails, pdfTriggered]);

  const roles_ids = roles?.map((r) => Number(r.id));
  const currentRoleId = props.rolesInfo?.currentRole?.id;

  const showButton = (button) => {
    const cert = certificateDetails?.[0];
    if (!cert) return false;
    if (cert?.certificate_rejectedBy) return false;
    if (!roles_ids?.includes(button)) return false;
    // Button shows only when ALL observation sheets have requestApproval == 1
    const allApproved = cert?.observationSheets?.length > 0 && cert.observationSheets.every(obs => obs.observationSheet_requestApproval == 1);

    let ret = cert.certificate_status != -1  && allApproved;
      // cert?.observationSheet_testedBy &&
      // cert.certificate_requestApproval == 1;

    // Check if a role is active in allSettings
    const isRoleActive = (keyName) => allSettings.some((s) => s.keyName === keyName && Number(s.status) === 1 && s.value !== "false");   // skip if value is explicitly "false"
    const role2Active = isRoleActive("activeRole2");
    const role3Active = isRoleActive("activeRole3");
    const role4Active = isRoleActive("activeRole4");

    switch (button) {
      case 2:
        ret =
          ret &&
          role2Active &&
          !cert?.certificate_preparedBy &&
          currentRoleId == 2;
        break;

      case 3:
        ret =
          ret &&
          (role2Active ? !!cert?.certificate_preparedBy : true) &&
          !cert?.certificate_reviewedBy &&
          currentRoleId == 3;
        break;

      case 4:
        ret =
          ret &&
          (role3Active ? !!cert?.certificate_reviewedBy : role2Active ? !!cert?.certificate_preparedBy : true) &&
          !cert?.certificate_authorizedBy &&
           role4Active &&
          currentRoleId == 4;
        break;

      default:
        ret = false;
        break;
    }

    return ret;
  };

  const getButtonConfig = () => {
    if (currentRoleId == 2) {
      return showButton(2) && { roleId: 2, label: "Prepared", color: "success" };
    } else if (currentRoleId == 3) {
      return showButton(3) && { roleId: 3, label: "Reviewed", color: "warning" };
    } else if (currentRoleId == 4) {
      return showButton(4) && { roleId: 4, label: "Authorized", color: "warning" };
    }
    return null;
  };

  const handleActionButtonClick = (label) => {
    const cert = certificateDetails?.[0];
    const testedBy = [cert?.observationSheets?.[0]?.observationSheet_testedBy, "Tested By"];
    const authorizedBy = [cert?.certificate_authorizedBy, "Authorized By"];

    if (label === "Prepared") {
      auhtorityWiseApprove("prepared", [cert?.id], testedBy, "", props.rolesInfo?.currentRole?.name, authorizedBy);
    } else if (label === "Reviewed") {
      auhtorityWiseApprove("review", [cert?.id], testedBy, "", props.rolesInfo?.currentRole?.name, authorizedBy);
    } else if (label === "Authorized") {
      auhtorityWiseApprove("authorized", [cert?.id], testedBy, "", props.rolesInfo?.currentRole?.name, authorizedBy);
    }
  };

  const renderActionButtons = () => {
    const config = getButtonConfig();
    if (!config) return null;

    return (
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <Button
          id={`certificate-certificateview_${config.label.toLowerCase()}btn`}
          variant="contained"
          color={config.color}
          size="small"
          onClick={() => handleActionButtonClick(config.label)}
        >
          {config.label}
        </Button>

        <Button
          id="certificate-certificateview_rejectbtn"
          variant="contained"
          color="error"
          size="small"
          onClick={() => setModalOpen(true)}
        >
          Reject
        </Button>
      </Box>
    );
  };

  if (certificateDetails.length === 0) {
    return (
      <div className="p-6 flex justify-center">
        <div className="text-lg">No certificates found.</div>
      </div>
    );
  }

  let printProps = { letterHead, draft, scanCopy, electronicSign, certificateDetails, setLoading, settings, allSettings };


  return (
    <>
      {(permissions.pdfDownload || permissions.allAccess) && (
        <div className="mb-5"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            alignItems: "flex-start",
            justifyContent: "flex-end",
          }}
        >
          {(() => {
            const isSingle = certificateDetails.length === 1;
            const isDraft = certificateDetails.some((c) => !getFinalApprovalValue(c));
            const isApproved = certificateDetails.some((c) => getFinalApprovalValue(c));

            const canDownload = permissions.pdfDownload || permissions.allAccess;
            if (!canDownload) return null;

            //  Case 1: Single Draft
            if (isSingle && isDraft) {
              return (
                <div style={{ flex: "0 0 auto" }}>
                  <AddButton
                    label="Download Draft"
                    id="certificate_download_draft"
                    onClick={() =>
                      generateCertificatePDF({
                        ...printProps,
                        draft: true,
                        letterHead: false,
                        scanCopy: false,
                      })
                    }
                  />
                </div>
              );
            }

            //  Case 2: Approved
            if (isApproved) {
              if (userType == 13){
                return(
                  <div style={{ flex: "0 0 auto", display: "flex", alignItems: "center" }}>
                    <AddButton
                      label="Download PDF"
                      id="certificate_generatepdf"
                      onClick={() => generateCertificatePDF(printProps)}
                    />
                  </div>)
              }
              return (
                <>
                  <div style={{ flex: "0 0 250px", maxWidth: "300px" }}>
                    <Autocomplete
                      disabled={draft}
                      size="small"
                      id="certificate-certificateviewletterhead"
                      options={[
                        { id: 1, label: "With Letter Head" },
                        { id: 2, label: "Without Letter Head" },
                      ]}
                      renderInput={(params) => <TextField {...params} label="Letter Head" />}
                      onInputChange={(event, newInputValue) => {
                        if (newInputValue === "With Letter Head" || newInputValue === "") {
                          setLetterHead(true);
                          setDraft(false);
                        } else if (newInputValue === "Without Letter Head") {
                          setLetterHead(false);
                        }
                      }}
                    />
                  </div>

              <div style={{ flex: "0 0 250px", maxWidth: "300px" }}>
                <Autocomplete
                  size="small"
                  options={
                    letterHead
                      ? [
                        { id: 1, label: "Scan Copy" },
                        { id: 2, label: "Without Scan Copy" },
                      ]
                      : [
                        { id: 1, label: "With Draft" },
                        { id: 2, label: "Without Draft" },
                      ]
                  }
                  renderInput={(params) => <TextField {...params} label="Draft" />}
                  onInputChange={(event, newInputValue) => {
                    if (newInputValue === "With Draft" || newInputValue === "") {
                      setDraft(true);
                      setLetterHead(false);
                      setScanCopy(false);
                    } else if (newInputValue === "Without Draft") {
                      setDraft(false);
                      setScanCopy(false);
                    } else if (newInputValue === "Scan Copy") {
                      setDraft(false);
                      setScanCopy(true);
                    } else if (newInputValue === "Without Scan Copy") {
                      setScanCopy(false);
                    }
                  }}
                />
          {/* <div style={{ flex: "1 1 250px", maxWidth: "300px" }}>
            <Autocomplete
              size="small"
              id="certificate__electronicsign"
              options={[
                { id: 1, label: "With Electronically Signed" },
                { id: 2, label: "Without Electronically Signed" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Electronically Signed" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Electronically Signed" ||
                  newInputValue === ""
                ) {
                  setElectronicSign(true);
                } else if (newInputValue === "Without Electronically Signed") {
                  setElectronicSign(false);
                }
              }}
            />
          </div> */}
              </div>

              <div style={{ flex: "0 0 auto", display: "flex", alignItems: "center" }}>
                <AddButton
                  label="Download PDF"
                  id="certificate_generatepdf"
                  onClick={() => generateCertificatePDF(printProps)}
                />
              </div>

              {userType != 13 && (<div style={{ flex: "0 0 auto", display: "flex", alignItems: "center" }}>
                <AddButton
                  label="Withdraw Approval"
                  id="certificate_withdrawapproval"
                  onClick={() => handleWithdrawApproval(certificateDetails?.[0]?.id)}
                />
              </div>)}
            </>
            );
            }

            //  Case 3: Multiple Drafts (no approved)
            if (!isApproved && !isSingle) {
              return (
                <div style={{ flex: "0 0 auto" }}>
                  <AddButton
                    label="Download Draft"
                    id="certificate_download_draft_multi"
                    onClick={() =>
                      generateCertificatePDF({
                        ...printProps,
                        draft: true,
                        letterHead: false,
                        scanCopy: false,
                      })
                    }
                  />
                </div>
              );
            }

            return null;
          })()}
        </div>
      )}
      <div className="pt-5 flex flex-col items-center gap-8">
        {certificateDetails.map((cert, index) => (
          <div
            key={cert?.id || index}
            className="bg-white shadow-lg rounded-lg w-full max-w-7xl border border-gray-400"
          >
            {/* Header */}
            <div className="text-center border-b border-gray-400 py-3">
              <h1 className="text-xl font-bold tracking-wide">TEST REPORT</h1>
            </div>

            {/* Top Info */}
            <div className="w-full text-sm p-4 border-b border-gray-400">
              <table className="w-full border border-gray-400 text-left border-collapse">
                <tbody>
                  <tr className="border border-gray-400">
                    <td className="w-[25%] p-2 border border-gray-400 font-semibold">ULR No. :</td>
                    <td className="w-[25%] p-2 border border-gray-400">
                      {cert?.certificate_ulrNumber}
                    </td>
                    <td className="w-[25%] p-2 border border-gray-400 font-semibold">Date :</td>
                    <td className="w-[25%] p-2 border border-gray-400">
                      {DateisValid(cert?.inward_inwardDate)}
                    </td>
                  </tr>
                  <tr className="border border-gray-400">
                    <td className="w-[25%] p-2 border border-gray-400 font-semibold">Report No :</td>
                    <td className="p-2 border border-gray-400">
                      {cert?.certificate_reportNumber}
                    </td>
                    <td className="p-2 border border-gray-400 font-semibold">Lab Reference No :</td>
                    <td className="p-2 border border-gray-400">
                      {cert?.inward_labReferenceNo}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="p-4 text-sm">
            {/* Customer Details */}
              <table className="w-full border border-gray-400 text-left">
                <tbody>
                {getCustomerDetails(cert)?.map((item, idx) => (
                  <tr
                    key={idx}
                    className={
                      idx === 0
                        ? "border border-gray-400"
                        : idx === getCustomerDetails(cert).length - 1
                          ? ""
                          : "border-b border-gray-400"
                    }
                  >
                    <td className="p-2 w-1/3 border-r border-gray-400 font-semibold">
                      {item.label}
                    </td>
                    <td className={`p-2 ${item.bold ? "font-bold" : ""}`}>
                      {item.value}
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
              
              {/* Note + file attachment + QR */}
              <div className="flex justify-between items-start pt-3">
                <div className="flex items-start justify-between gap-3 w-full">
                  {/* note section */}
                  {/* {cert?.observationSheet_configuration?.remark && ( */}
                    <div className="px-1 text-sm max-w-[100%]">
                      <p className="font-bold mb-1">Note:</p>
                      <pre style={{
                          fontFamily: "Calibri, sans-serif",
                          fontSize: "1rem",
                          marginBottom: "0px",
                          whiteSpace: "pre-wrap",
                        }}>
                          {cert?.witnessString && settings?.["ObservationWitnessHistory"] === "true" && (
                            <p className="mt-2 text-sm">The Test is Witnessed By: {cert.witnessString}</p>  
                          )}
                        {/* <p>{cert.observationSheet_configuration.remark}</p> */}
                        <p>1. The laboratory studies and test results pertain only to the samples supplied by the customer.<br />
                          2. S & R Geotechniques Pvt Ltd will not be responsible with respect   to any claims, damages or losses from the use of above test report.<br />
                          3. The above test results are related to the sample tested.<br />
                          4. The test results cannot be used as evidence in any court or legal proceedings.<br />
                          5. Test report shall not be reproduced except in full, without written approval by S & R Geotechniques Pvt Ltd<br />
                          6. *As furnished by customer.</p>
                      </pre>
                    </div>
                  {/* )} */}

                  {/* File attachment — use first obs sheet's attachment */}
                  {/* {cert?.observationSheets?.[0]?.observationSheet_fileAttachment &&
                    cert.observationSheets[0].observationSheet_fileAttachment?.split(",")?.[0] &&
                    /\.(jpg|jpeg|png|webp)$/i.test(
                      cert.observationSheets[0].observationSheet_fileAttachment?.split(",")?.[0]
                    ) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "stretch",
                          padding: "0px 5px",
                          maxHeight: "115px",
                          width: "150px",
                          flexDirection: "column",
                        }}
                      >
                        <img
                          src={cert.observationSheets[0].observationSheet_fileAttachment?.split(",")?.[0] || ""}
                          alt="weighttrect"
                          style={{ height: "90%", width: "100%" }}
                        />
                      </div>
                    )} */}
                </div>

              </div>
              <div className="flex justify-between items-center mt-3">
                {/* QR code */}
                <div className="flex flex-col items-center gap-2">
                  <QRCode
                    value={`${DOMAIN}/#/certificate/print/${cert?.id}`}
                    align="center"
                    size={80}
                  />
                  <h6>Scan To Get Report</h6>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <QRCode
                    value={`https://nablwp.qci.org.in/CertificateScopenew?x=VmSWOJQnmhIZrAXaua7hDA==&a=NzU3MzU=`}
                    align="center"
                    size={80}
                  />
                  <h6>Scan For NABL Certificate</h6>
                </div>
              </div>

              {/* Authorization Table */}
              <table className="w-full border border-gray-400 text-sm border-collapse mt-4">
                <thead>
                  <tr>
                    <th className="border border-gray-400 p-2 text-center bg-gray-100">Action/ Name</th>
                    <th className="border border-gray-400 p-2 text-center bg-gray-100">Designation</th>
                    {/* <th className="border border-gray-400 p-2 text-center bg-gray-100">Qualification</th> */}
                    <th className="border border-gray-400 p-2 text-center bg-gray-100">Date</th>
                    <th className="border border-gray-400 p-2 text-center bg-gray-100">Signature</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(cert?.certificate_footer || {})
                    .filter(([key]) =>
                      ["preparedBy", "reviewedBy", "authorizedBy"].includes(key)
                    ).map(([key, value], index) => (
                    <tr key={key || index}>
                      <td className="border border-gray-400 p-2 text-center">
                        <b>{value?.label}</b> <br /> {value?.userName || "-"}
                      </td>
                      <td className="border border-gray-400 p-2 text-center">{value?.hrDesignation || "-"}</td>
                      {/* <td className="border border-gray-400 p-2 text-center">B.Tech. (Civil)</td> */}
                      <td className="border border-gray-400 p-2 text-center">{DateisValid(cert?.certificate_preparedDate) || "-"}</td>
                      <td className="border border-gray-400 p-2 text-center">
                        {value?.usersign ? (
                          <img src={value?.usersign}
                            alt="signature" className="h-10 object-contain mx-auto"
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* summary Report */}
              {settings?.["CertificateSummaryReportPrint"] === "true" && cert?.inward_locations == 1 && (
                <>
                  <h2 className="text-center text-lg my-4 font-bold">{summaryLable}</h2>
                 {settings?.["CertificateSummaryVertical"] === "true" ? (                  
                  <table className="w-full border border-gray-400 text-sm border-collapse">
                    <thead>
                      <tr>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={2}>S.No</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={2}>TEST PARAMETER</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={2}>UNIT</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" colSpan={(cert?.inwardTestsList || []).length}
                        >Bore Hole No</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={2}>TEST METHOD</th>
                      </tr>
                      <tr>
                        {(cert?.inwardTestsList || []).map((row, idx) => (
                          <th
                            key={idx}
                            className="border border-gray-400 p-2 text-center bg-gray-100 text-xs whitespace-nowrap"
                          >
                            {/* // change column name future add dynamic */}
                            {row.boreHoleNo || idx + 1}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(cert?.inwardTestsHeaders || []).map((header, index) => (
                        <tr
                          key={`row-${header.testId}-${header.columnKey}-${index}`}
                        >
                          {/* S.No — only on first column of each test */}
                          {header.isFirstColumn && (
                            <td
                              className="border border-gray-400 p-2 text-center font-semibold"
                              rowSpan={header.columnSpan}
                            >
                              {/* count unique tests up to this point */}
                              {
                                (cert?.inwardTestsHeaders || []).filter(
                                  (h, i) => h.isFirstColumn && i <= index
                                ).length
                              }
                            </td>
                          )}

                          {/* TEST PARAMETER = testName rowSpan + columnName */}
                          {header.isFirstColumn ? (
                            <td
                              className="border border-gray-400 p-2 font-semibold"
                              rowSpan={header.columnSpan}
                            >
                              {header.testName}
                            </td>
                          ) : null}

                          {/* UNIT = columnUnit */}
                          <td className="border border-gray-400 p-2 text-center whitespace-nowrap">
                            {header.columnUnit || "-"}
                          </td>

                          {/* Data values — one per sample */}
                          {(cert?.inwardTestsList || []).map((row, idx) => (
                            <td
                              key={`val-${header.testId}-${header.columnKey}-${idx}`}
                              className="border border-gray-400 p-2 text-center whitespace-nowrap"
                            >
                              {row.readingByTestId?.[header.testId]?.[
                                header.columnKey
                              ] || "-"}
                            </td>
                          ))}

                          {/* TEST METHOD — only on first column of each test */}
                          {header.isFirstColumn && (
                            <td
                              className="border border-gray-400 p-2 text-center text-xs"
                              rowSpan={header.columnSpan}
                            >
                              {header.testMethod || "-"}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  ) : (
                  <table className="w-full border border-gray-400 text-sm border-collapse">
                    <thead>
                      <tr>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={3}>Sr No</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={3}>Bore Hole No</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={3}>Depth</th>
                        <th className="border border-gray-400 p-2 text-center bg-gray-50" rowSpan={3}>Sample Type</th>
                        {(cert?.inwardTestsHeaders || []).map((header, index) => (
                          header.isFirstColumn ? (
                            <th
                              key={`test-${header.testId}-${index}`}
                              className="border border-gray-400 p-2 text-center bg-gray-50"
                              colSpan={header.columnSpan}
                            >
                              {header.testName}
                            </th>
                          ) : null
                        ))}
                      </tr>
                      {/* Second header row - Column Names */}
                      <tr>
                        {(cert?.inwardTestsHeaders || []).map((header, index) => (
                          <th key={`col-${header.testId}-${header.columnKey}-${index}`} className="border border-gray-400 p-2 text-center bg-gray-100 text-xs">
                            {header.testMethod}
                          </th>
                        ))}
                      </tr>
                      {/* Second header row - Column Names */}
                      <tr>
                        {(cert?.inwardTestsHeaders || []).map((header, index) => (
                          <th key={`col-${header.testId}-${header.columnKey}-${index}`} className="border border-gray-400 p-2 text-center bg-gray-100 text-xs">
                            {header.columnName}{header.columnUnit ? ` (${header.columnUnit})` : ""}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(cert?.inwardTestsList || []).map((row, index) => (
                        <tr key={row.id || index}>
                          <td className="border border-gray-400 p-2 text-center">{index + 1}</td>
                           {/* // change column name future add dynamic */}
                          <td className="border border-gray-400 p-2 text-center">{row.boreHoleNo || "-"}</td>
                          <td className="border border-gray-400 p-2 text-center">{parseDepth(row.fromDepth) || "-"} to {parseDepth(row.toDepth) || "-"}</td>
                          <td className="border border-gray-400 p-2 text-center">{row.sampleType || "-"}</td>
                          {(cert?.inwardTestsHeaders || []).map((header, idx) => (
                            <td key={`data-${header.testId}-${header.columnKey}-${idx}`} className="border border-gray-400 p-2 text-center whitespace-nowrap">
                              {row.readingByTestId?.[header.testId]?.[header.columnKey] || "-"}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  )}
                </>
              )}

              {/* ── Loop observation sheets one by one ── */}
              {settings?.["CertificateObserVationSheetPrint"] === "true" && (
                (cert.observationSheets || []).map((obs, obsIdx) => (
                <div key={obs.observationSheet_id || obsIdx} className="mt-4">

                  {/* ── Per observation sheet info table ── */}
                  <table className="w-full border border-gray-400 text-sm border-collapse mb-2">
                    <tbody>
                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold w-[25%]">Report No</td>
                        <td colSpan={3} className="p-2 border border-gray-400">{obs?.observationSheet_reportNumber}</td>
                      </tr>
                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Job No</td>
                        <td colSpan={3} className="p-2 border border-gray-400">{obs?.jobRegister_jobNumber || ""}</td>
                      </tr>
                      <tr>
                        <td className="p-2 border border-gray-400 font-bold text-center" colSpan={4}>
                          {obs?.materialTestings_testName && (
                            <span>{obs.materialTestings_testName}</span>
                          )}
                          {obs?.materialTestings_testName && obs?.materialTestings_testMethod && <br />}
                          {obs?.materialTestings_testMethod && (
                            <span>{obs.materialTestings_testMethod}</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Project</td>
                        <td colSpan={3} className="p-2 border border-gray-400">{obs?.jobRegister_projectName || ""}</td>
                      </tr>

                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Principal Client</td>
                        <td className="p-2 border border-gray-400">{obs?.inward_principleClient || ""}</td>
                        <td className="p-2 border border-gray-400 font-semibold">Date</td>
                        <td className="p-2 border border-gray-400">{DateisValid(obs?.observationSheet_startTestingDate)}</td>
                      </tr>
                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Client</td>
                        <td colSpan={3} className="p-2 border border-gray-400">
                          {obs?.jobRegister_clientName || ""}
                        </td>
                        {/* <td className="p-2 border border-gray-400 font-semibold">Date</td>
                        <td className="p-2 border border-gray-400">
                          {DateisValid(obs?.observationSheet_endTestingDate)}
                        </td> */}
                      </tr>
                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Location</td>
                        <td className="p-2 border border-gray-400">{obs?.inwardTests_locationChainageNo || ""}</td>
                        <td className="p-2 border border-gray-400 font-semibold">Bore Hole No</td>
                        <td className="p-2 border border-gray-400">{obs?.inwardTests_boreHoleNo || ""}</td>
                      </tr>

                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Length of Specimen (cm)</td>
                        <td className="p-2 border border-gray-400">{obs?.inwardTests_lengthOfRock || ""}</td>
                        <td className="p-2 border border-gray-400 font-semibold">Depth (m)</td>
                        <td className="p-2 border border-gray-400">
                          {obs?.inwardTests_fromDepth || obs?.inwardTests_toDepth ? `${obs?.inwardTests_fromDepth ?? ""} - ${obs?.inwardTests_toDepth ?? ""}` : ""}
                        </td>
                      </tr>

                      <tr>
                        <td className="p-2 border border-gray-400 font-semibold">Condition of Test</td>
                        <td className="p-2 border border-gray-400">{obs?.inwardTests_sampleType || ""}</td>
                      </tr>

                      {(() => {
                        const additionalEntries = Object.entries(obs?.observationSheet_additionalTestDetails || {});
                        const rows = [];
                        for (let i = 0; i < additionalEntries.length; i += 2) {
                          rows.push(
                            <tr key={i}>
                              <td className="p-2 border border-gray-400 font-semibold">{additionalEntries[i]?.[0] || ""}
                              </td>
                              <td className="p-2 border border-gray-400">{additionalEntries[i]?.[1] || ""}</td>
                              <td className="p-2 border border-gray-400 font-semibold">{additionalEntries[i + 1]?.[0] || ""}</td>
                              <td className="p-2 border border-gray-400">{additionalEntries[i + 1]?.[1] || ""}</td>
                            </tr>
                          );
                        }
                        return rows;
                      })()}

                    </tbody>
                  </table>

                  {/* RenderStaticTables — unchanged, called once per obs sheet */}
                  <RenderStaticTables
                    tableDisplayStatus={obs.tableDisplayStatus}
                    configuration={obs.observationSheet_configuration || {}}
                    certificateId={obs.observationSheet_id}
                    tableDivide={obs.tableDivide}
                    staticCertificateReadings={obs.readingRows}
                    staticTables={obs.staticTables}
                  />

                  {/* Divider between sheets, skip after last */}
                  {obsIdx < cert.observationSheets.length - 1 && (
                    <hr className="my-4 border-gray-300" />
                  )}
                </div>
               )))}
            </div>
            <br />

          </div>
        ))}
        <br />
      </div>

      <LoaderModal loading={loading} />

      <RejectModal
        open={modalOpen}
        handleClose={handleClose}
        onReject={(reason) => handleReject(reason)}
      />

      <Toolbar style={{ padding: "16px", width: "100%", justifyContent: "flex-end" }}>
        {renderActionButtons()}
      </Toolbar>
    </>
  );
};

export default ViewCertificate;
